import React, { PropsWithChildren, useMemo } from 'react';
import { ActivitiesContext, ActivitiesContextData } from '.';

interface ActivitiesContextProviderProps {
  value: ActivitiesContextData;
}

export function ActivitiesContextProvider({
  value,
  children,
}: PropsWithChildren<ActivitiesContextProviderProps>): JSX.Element {
  const providerValue = useMemo(() => value, [value]);

  return (
    <ActivitiesContext.Provider value={providerValue}>
      {children}
    </ActivitiesContext.Provider>
  );
}
